import { Injectable } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConfirmationDialogComponent } from '../views/components/confirmation-dialog/confirmation-dialog.component';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../views/components/snack-bar/snack-bar.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HostConnectionService } from './host-connection.service';
declare var $: any;
declare var bootstrap: any;

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  customerId: string = '3F2504E0-4F89-11D3-9A0C-0305E82C3301';
  connectorId: string | null = null;
  static filtersStepTypeId: number = 15;
  static schedulerStepTypeId: number = 2;
  static schedulerHourlyStepTypeId: number = 4;
  static encompassLoanEventStepTypeId: number = 8;
  static errorEmailStepTypeId: number = 39;
  static triggerRerunStepTypeId: number = 54;
  static emailStepTypeId: number = 28;
  static filtersStepTypeName: string = 'Filters';
  static printToeFolderStepTypeId: number = 22;
  static printToeFolderSubStepTypeId: number = 43;
  static reportStepTypeId: number = 37;
  static webhookStepTypeId: number = 5;
  static manualTriggerStepTypeId: number = 6;
  static initialDisclosureStepTypeId: number = 19;

  static fieldsLimit: number = 1000;
  workflowId: string = '';

stateList: any[] = [
  { key: "AL", value: "Alabama" },
  { key: "AK", value: "Alaska" },
  { key: "AZ", value: "Arizona" },
  { key: "AR", value: "Arkansas" },
  { key: "CA", value: "California" },
  { key: "CO", value: "Colorado" },
  { key: "CT", value: "Connecticut" },
  { key: "DE", value: "Delaware" },
  { key: "FL", value: "Florida" },
  { key: "GA", value: "Georgia" },
  { key: "HI", value: "Hawaii" },
  { key: "ID", value: "Idaho" },
  { key: "IL", value: "Illinois" },
  { key: "IN", value: "Indiana" },
  { key: "IA", value: "Iowa" },
  { key: "KS", value: "Kansas" },
  { key: "KY", value: "Kentucky" },
  { key: "LA", value: "Louisiana" },
  { key: "ME", value: "Maine" },
  { key: "MD", value: "Maryland" },
  { key: "MA", value: "Massachusetts" },
  { key: "MI", value: "Michigan" },
  { key: "MN", value: "Minnesota" },
  { key: "MS", value: "Mississippi" },
  { key: "MO", value: "Missouri" },
  { key: "MT", value: "Montana" },
  { key: "NE", value: "Nebraska" },
  { key: "NV", value: "Nevada" },
  { key: "NH", value: "New Hampshire" },
  { key: "NJ", value: "New Jersey" },
  { key: "NM", value: "New Mexico" },
  { key: "NY", value: "New York" },
  { key: "NC", value: "North Carolina" },
  { key: "ND", value: "North Dakota" },
  { key: "OH", value: "Ohio" },
  { key: "OK", value: "Oklahoma" },
  { key: "OR", value: "Oregon" },
  { key: "PA", value: "Pennsylvania" },
  { key: "RI", value: "Rhode Island" },
  { key: "SC", value: "South Carolina" },
  { key: "SD", value: "South Dakota" },
  { key: "TN", value: "Tennessee" },
  { key: "TX", value: "Texas" },
  { key: "UT", value: "Utah" },
  { key: "VT", value: "Vermont" },
  { key: "VA", value: "Virginia" },
  { key: "WA", value: "Washington" },
  { key: "WV", value: "West Virginia" },
  { key: "WI", value: "Wisconsin" },
  { key: "WY", value: "Wyoming" }
];


  constructor(private dialog: MatDialog, private _snackBar: MatSnackBar, private spinner: NgxUiLoaderService, private hostService: HostConnectionService) { }

  confirm(title: string, message: string): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '300px',
      data: { title, message },
    });

    return dialogRef.afterClosed(); // Returns an Observable<boolean>
  }

  appVersion: string = '1.1.4.2-02272025';

  startSpinner() {
    this.spinner.start();
  }
  stopSpinner() {
    this.spinner.stop();
  }

  openSnackBar(message: string, action: string, type: string) {
    const configSuccess = {
      horizontalPosition: 'center' as MatSnackBarHorizontalPosition,
      verticalPosition: 'top' as MatSnackBarVerticalPosition,
      panelClass: ['custom-snackbar', 'cs-success'],
      duration: 2000,
      data: {
        title: 'Success',
        icon: 'done',
        //items: ['Item 1', 'Item 2', 'Item 3']
        message: message
      }
    };
    const configWarning = {
      horizontalPosition: 'center' as MatSnackBarHorizontalPosition,
      verticalPosition: 'top' as MatSnackBarVerticalPosition,
      panelClass: ['custom-snackbar', 'cs-warning'],  // Change this to a warning-specific class
      duration: 4000,
      data: {
        title: 'Warning',
        icon: 'warning',  // Change the icon to a warning icon
        message: message  // Set the warning message
      }
    };

    const configError = {
      horizontalPosition: 'center' as MatSnackBarHorizontalPosition,
      verticalPosition: 'top' as MatSnackBarVerticalPosition,
      panelClass: ['custom-snackbar', 'cs-error'],
      duration: 6000,
      data: {
        title: 'Error',
        icon: 'gpp_maybe',
        //items: ['Item 1', 'Item 2', 'Item 3']
        message: message
      }
    };

    let config: any;
    if (type === 'success')
      config = configSuccess;
    else if (type === 'warning')
      config = configWarning;
    else
      config = configError;

    const snackBarRef = this._snackBar.openFromComponent(SnackBarComponent, config);
  }

  resetControlsForLogout() {
    this.stopSpinner();
    $('.modal').modal('hide');
    //if ($('.modal.show').length > 0)
  }

  getErrorMessage(dataObject: any): string {
    if (dataObject && dataObject.errors) {
      if (dataObject.hasError('required')) {
        return 'You must enter a value';
      }
      if (dataObject.hasError('email')) {
        return 'You must enter a valid email';
      }
      if (dataObject.hasError('numberField')) {
        return 'You must enter a valid number';
      }
      if (dataObject.hasError('pattern')) {
        return 'You must enter a valid value';
      }
      if (dataObject.hasError('maxlength')) {
        return `Maximum allowed length is ${dataObject.getError('maxlength')?.requiredLength}`;
      }
      if (dataObject.hasError('minlength')) {
        return `Minimum required length is ${dataObject.getError('minlength')?.requiredLength}`;
      }
      if (dataObject.hasError('max')) {
        return `Maximum allowed value is ${dataObject.getError('max')?.max}`;
      }
      if (dataObject.hasError('min')) {
        return `Minimum allowed value is ${dataObject.getError('min')?.min}`;
      }
      if (dataObject.hasError('pattern')) {
        return `Pattern allowed value is ${dataObject.getError('pattern')?.min}`;
      }
    }
    return '';
  }

  onReset(form: any): void {
    form.reset();

    // Set form controls to untouched, pristine
    Object.keys(form.controls).forEach((key) => {
      const control = form.get(key);
      control?.markAsPristine(); // Marks the control as pristine
      control?.markAsUntouched(); // Marks the control as untouched
    });

  }

  showConfigurationRightDialog() {
    $("#configurationRightDialog").modal('show');
  }
  hideConfigurationRightDialog() {
    $("#configurationRightDialog").modal('hide');
  }

  private sessionModalInstance: any;
  private countdownInterval: any;
  public countdownValue: number = 60;
  openSessionExpiredModal() {
    this.countdownValue = 60;
    const modalElement = document.getElementById('sessionExpiredModal');
    if (modalElement) {
      this.sessionModalInstance = new bootstrap.Modal(modalElement, {
        backdrop: 'static',
        keyboard: false,
      });
      this.sessionModalInstance.show();
      // Start countdown
      this.startCountdown();
    }
  }
  closeSessionExpiredModal() {
    this.clearCountdown();
    if(this.sessionModalInstance){
      this.sessionModalInstance.hide();
    }
  }

   private startCountdown() {
    this.clearCountdown(); // clear any previous
    const countdownLabel = document.getElementById('countdownValue');
      if (countdownLabel)         
        countdownLabel.innerText = this.countdownValue.toString();
      
    this.countdownInterval = setInterval(() => {
      this.countdownValue--;
     
      if (countdownLabel) 
        countdownLabel.innerText = this.countdownValue.toString();      

      if (this.countdownValue <= 0) {
        this.clearCountdown();
        this.hostService.close(); // auto logout or redirect
      }
    }, 1000);
  }

  private clearCountdown() {
    this.countdownValue = 60;
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }


  // User  
  private userSubject = new BehaviorSubject<any>(null); // default: null
  user$ = this.userSubject.asObservable(); // Expose as observable
  setUser(user: any) {
    this.userSubject.next(user);
  }
  get currentUser(): any {
    return this.userSubject.value;
  }
  // End User


  descriptionPopoverContent(popoverId: string, descriptionList: any) {
    const tableRows = descriptionList.map((item: any) => {
      return `
        <tr style="border-bottom: 1px solid #eee;">
          <td>
            <span style="font-weight: bold;"> ${item.title} </span> - <span style="color: #454444;"> ${item.description} </span> 
          </td>
        </tr>`;
    }).join('');
    const content = `
    <div style="max-height: 300px; overflow-y: auto;">
      <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
        <tbody>
          ${tableRows}
        </tbody>
      </table>
    </div>`;
    const $popoverElement = $(popoverId);
    $popoverElement.popover('dispose');
    $popoverElement.popover({
      html: true,
      sanitize: false,
      placement: 'top',
      content: content,
      template: '<div class="popover custom-token-popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    });
    this.addClickEventsToTokenPopover();
  }
  addClickEventsToTokenPopover() {
    $(document).off('click.tokenPopover');
    $(document).on('click.tokenPopover', (e: any) => {
      const $target = $(e.target);
      // --- COPY LOGIC ---
      if ($target.hasClass('copy-token-btn')) {
        const tokenText = $target.attr('data-token');
        if (tokenText) {
          navigator.clipboard.writeText(tokenText).then(() => {
            this.updateTooltipCopied(e.target); // Trigger your existing tooltip feedback
          });
        }
        return; // Don't close the popover when clicking copy
      }
      // --- CLOSE LOGIC ---
      const isClickInsidePopover = $target.closest('.popover').length > 0;
      const isClickOnTrigger = $target.closest('.title-popover-info-icon').length > 0;
      if (!isClickInsidePopover && !isClickOnTrigger) {
        $('.popover').popover('hide');
      }
    });
  }
  destroyPopoverEvents() {
    $(document).off('click.tokenPopover');
    $('.popover').popover('dispose');
  }

  updateTooltipCopied(targetElement: any): void {
    // Ensure jQuery and Bootstrap are loaded when this runs
    const $button = $(targetElement);
    const originalTitle = 'Click to copy';
    const newTitle = 'Copied!';
    // 1. Update the title attribute and dispose old tooltip
    $button.attr('title', newTitle).tooltip('dispose');
    // 2. Re-initialize and show the tooltip with the new title
    $button.tooltip({
      title: newTitle,
      trigger: 'manual'
    }).tooltip('show');
    // 3. Revert the title and hide the tooltip after 2 seconds
    setTimeout(() => {
      $button.tooltip('hide');
      // Dispose and re-initialize for standard hover/focus behavior
      $button.tooltip('dispose');
      $button.attr('title', originalTitle);
      $button.tooltip();
    }, 2000);
  }


}
